<template>
  <router-link
    v-if="!active"
    :to="path"
    class="menu-item"
    :class="classRouter"
  >
    <img
      v-if="showIcon"
      :src="menuItem.icon"
    >
    <div class="item-text">
      {{ menuItem.text }}
    </div>
  </router-link>

  <router-link
    v-else
    :to="path"
    class="menu-item menu-item-info"
    :class="classRouter"
  >
    <img
      v-if="showIcon"
      :src="menuItem.icon"
    >
    <div class="item-text">
      {{ menuItem.text }}
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'AppHeaderNavigationItem',
  props: {
    menuItem: {
      type: Object,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {
    showIcon: function () {
      return this.menuItem.icon !== '' && this.menuItem.icon !== undefined
    },

    path () {
      return this.menuItem.path
    },
    classRouter () {
      var classVisible = this.visible ? 'router-link-not-active' : null
      return classVisible
    }

  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.menu-item {
  height: 100%;
  padding: 0 12px;
  margin: 0 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: $color-neutral-light-4;
  text-decoration: none;

  img {
    margin-right: 8px;
    filter: invert(32%) sepia(26%) saturate(344%) hue-rotate(171deg) brightness(100%) contrast(91%);
  }

  .item-text {
    min-width: fit-content;
    font-size: 16px;
  }

  &.router-link-active {
    border-bottom: 2px solid $color-accent;
    font-weight: 700;
    color: $color-accent;

    img {
      filter: invert(69%) sepia(72%) saturate(6261%) hue-rotate(227deg) brightness(99%) contrast(94%);
    }
  }
  &.router-link-not-active {
    border-bottom: none;
    font-weight: normal;
    color: $color-neutral-light-4;

    img {
      filter: invert(32%) sepia(26%) saturate(344%) hue-rotate(171deg) brightness(100%) contrast(91%);
    }
  }
}
.menu-item-info{
   &.router-link-active {
   border-bottom: none;
    font-weight: normal;
    border-radius: 8px;
    background-color: #ECE7FE;
    color: $color-neutral-light-4;

    img {
     filter: invert(32%) sepia(26%) saturate(344%) hue-rotate(171deg) brightness(100%) contrast(91%);
    }
  }
}
</style>
